import Link from '@talkdesk/cobalt-react-link'
import Flex from '@talkdesk/cobalt-react-flex'
import Base from '../../pages/Base'
import RecoveryOTP from '../../components/RecoveryOTP'
import TOTP from '../../components/TOTP'
import WebAuthn from '../../components/WebAuthn'
import { MFA_FOOTNOTE_ACTION } from '../../constants/ui.labels'
import * as MFATypes from '../../constants/mfa.types'
import { MFA_SELECTOR } from '../../constants/steps'

const getMFAMechanism = ({
  mfa,
  metadata,
  loginTimestamp,
  talkdeskIdAssetsURL,
  ...props
}) =>
  ({
    [MFATypes.RECOVERY_OTP]: <RecoveryOTP {...props} />,
    [MFATypes.TOTP]: <TOTP {...props} />,
    [MFATypes.WEB_AUTH]: (
      <WebAuthn
        data={mfa.data}
        webAuthnTokenTtl={
          metadata && metadata.webAuthn ? metadata.webAuthn.ttl : null
        }
        loginTimestamp={loginTimestamp}
        talkdeskIdAssetsURL={talkdeskIdAssetsURL}
        {...props}
      />
    )
  }[mfa.type.toUpperCase()])

const MFA = props => (
  <Base
    brandingSettings={props.brandingSettings}
    redirect={props.redirect}
    showGoogleFooterLink={props.showGoogleFooterLink}
  >
    {getMFAMechanism(props)}
    <Flex paddingTop={4} alignX="center">
      <Link
        onClick={() => props.changeStep(MFA_SELECTOR)}
        style={{ lineHeight: 'normal' }}
      >
        {MFA_FOOTNOTE_ACTION}
      </Link>
    </Flex>
  </Base>
)

export default MFA
